import React from "react";

export type Side = "front" | "left" | "right" | "back";

const PRIMARY = "var(--bs-primary, #ff5a1f)";

const SIDE_LETTERS: Record<Side, string> = { front: "A", left: "B", back: "C", right: "D" };
const SIDE_LABELS: Record<Side, string> = { front: "Frontale", left: "Sinistro", back: "Posteriore", right: "Destro" };

// Riquadro tratteggiato con la barra che indica il lato
const iconBox: React.CSSProperties = {
  width: 36,
  height: 36,
  border: "1px dashed #999",
  display: "flex",
};

const SIDE_ICONS: Record<Side, { box: React.CSSProperties; bar: React.CSSProperties }> = {
  front: { box: { alignItems: "flex-end", justifyContent: "center" }, bar: { width: "80%", height: 4 } },
  back: { box: { alignItems: "flex-start", justifyContent: "center" }, bar: { width: "80%", height: 4 } },
  left: { box: { alignItems: "center", justifyContent: "flex-start" }, bar: { width: 4, height: "80%" } },
  right: { box: { alignItems: "center", justifyContent: "flex-end" }, bar: { width: 4, height: "80%" } },
};

type SideSelectorProps = {
  sides: Side[];
  value: Side;
  onChange: (side: Side) => void;
};

/** Selettore del lato a card, condiviso dagli step della pergola che lavorano per lato. */
export const SideSelector = ({ sides, value, onChange }: SideSelectorProps) => (
  <div>
    <h6 style={{ fontWeight: 500, marginBottom: 12 }}>1. Seleziona il lato</h6>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(72px, 1fr))", gap: 8 }}>
      {sides.map((s) => {
        const selected = s === value;
        return (
          <button
            key={s}
            type="button"
            onClick={() => onChange(s)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 6,
              padding: "8px 4px",
              borderRadius: 8,
              border: `1px solid ${selected ? PRIMARY : "#e0e0e0"}`,
              background: selected ? "rgba(255, 90, 31, 0.08)" : "#fff",
              boxShadow: selected ? "0 2px 8px rgba(0,0,0,0.12)" : "none",
              color: selected ? PRIMARY : "inherit",
              cursor: "pointer",
              transition: "0.2s",
            }}
          >
            <div style={{ ...iconBox, ...SIDE_ICONS[s].box }}>
              <div style={{ ...SIDE_ICONS[s].bar, background: PRIMARY }} />
            </div>
            <div style={{ textAlign: "center", lineHeight: 1.2 }}>
              <div style={{ fontWeight: 700 }}>{SIDE_LETTERS[s]}</div>
              <div style={{ fontSize: "0.875rem" }}>{SIDE_LABELS[s]}</div>
            </div>
          </button>
        );
      })}
    </div>
  </div>
);
